import React, {ChangeEvent, useEffect, useState} from "react";

import "./BankOfAmericaCreditCardInput.scss";
import {BankOfAmericaFlexMicroform} from "../../../../context/BankOfAmericaContext";

interface BankOfAmericaCreditCardInputProps {
    bankOfAmericaFlexMicroform: BankOfAmericaFlexMicroform;
}

export const BankOfAmericaCreditCardInput: React.FunctionComponent<BankOfAmericaCreditCardInputProps> = (props) => {
    useEffect(() => {
        if(props.bankOfAmericaFlexMicroform) {
            const numberField = props.bankOfAmericaFlexMicroform.createField('number', {placeholder: ''});
            numberField.load('#bank-of-america-credit-card-container');
        }
    }, [props.bankOfAmericaFlexMicroform]);

    return <div className="bank-of-america-credit-card-container" id="bank-of-america-credit-card-container">
    </div>
}
